import { Box, FileUpload, Spinner } from '@chakra-ui/react';
import type { FileUploadFileChangeDetails } from '@chakra-ui/react';
import { getOr, take, size } from 'lodash/fp';
import { useAppStore } from '@halo/chat-sdk-react';

type ImgUploadPropsType = {
  onAddImg: (val: string) => void;
  imgLen: number;
};

export function ImgUpload({ onAddImg, imgLen }: ImgUploadPropsType) {
  const client = useAppStore((state) => state.client);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (details: FileUploadFileChangeDetails) => {
    const files = getOr(null, ['acceptedFiles'], details);

    const imageFiles = take(
      3 - imgLen,
      files?.filter((file) => file.type.startsWith('image/'))
    );

    if (!size(imageFiles)) return;

    setLoading(true);

    try {
      await Promise.all(
        imageFiles?.map(async (file) => {
          const res = await client?.Api.common.getUploadAvatar({
            file,
            type: file.name.split('.').pop(),
            category: 'avatar',
          });

          res && onAddImg(res);
        })
      );
    } catch (_) {
      //
    } finally {
      setLoading(false);
    }
  };

  return (
    <FileUpload.Root
      maxFiles={Number.MAX_SAFE_INTEGER}
      onFileChange={handleFileChange}
      accept={['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif']}
    >
      <FileUpload.HiddenInput />
      <FileUpload.Trigger asChild>
        <Box
          w="90px"
          h="90px"
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          cursor={'pointer'}
          borderRadius={'6px'}
          backgroundColor="#EBEBEB"
        >
          {loading ? (
            <Spinner />
          ) : (
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.962891 8.18829H15.4098M8.18633 0.964844V15.4117"
                stroke="#A3A3A3"
                strokeWidth="1.92625"
                strokeLinecap="round"
              />
            </svg>
          )}
        </Box>
      </FileUpload.Trigger>
    </FileUpload.Root>
  );
}
